/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckArticle } from '../../models/check-article';
import { EnrichedVirtualArticle } from '../../models/enriched-virtual-article';
import { KeyType } from '../../models/key-type';

export interface CheckBundleGroupVirtualArticle$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
  virtualArticleKey: string;
      body: CheckArticle
}

export function checkBundleGroupVirtualArticle(http: HttpClient, rootUrl: string, params: CheckBundleGroupVirtualArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrichedVirtualArticle>> {
  const rb = new RequestBuilder(rootUrl, checkBundleGroupVirtualArticle.PATH, 'patch');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
    rb.path('virtualArticleKey', params.virtualArticleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnrichedVirtualArticle>;
    })
  );
}

checkBundleGroupVirtualArticle.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/check';
